export const WASH_STATUS_ORDER = [
  "booked",
  "confirmed",
  "assigned",
  "on_the_way",
  "in_progress",
  "completed",
] as const;

export const STATUS_LABELS: Record<string, string> = {
  booked: "Booked",
  confirmed: "Confirmed",
  assigned: "Assigned",
  on_the_way: "On the way",
  in_progress: "In progress",
  completed: "Completed",
  cancelled: "Cancelled",
};
